import format from 'date-fns/format';
import isDate from 'date-fns/isDate';

export const DATE_FORMAT = 'dd.MM.yyyy';
export const DATETIME_FORMAT = 'dd.MM.yyyy HH:mm';
export const DATE_FORMAT_GLOBAL = 'yyyy-MM-dd';

export const formatDate = date => format(new Date(date), DATE_FORMAT);
export const formatDateTime = date => format(new Date(date), DATETIME_FORMAT);
export const formatDateGlobal = date =>
  format(isDate(date) ? date : new Date(date), DATE_FORMAT_GLOBAL);

export const getDay = date => format(new Date(date), 'dd');

export const getMonthYear = date => format(new Date(date), 'MM.yyyy');
